module.exports = __webpack_public_path__ + "img/cross.24f6b1f0.png";